import {InquiryTerms} from 'src/service/constant/text'

const useModalText = () => {
    const ModalTextOptions: any = [
        {
            idx: 200,
            title: '휴대폰 번호를 입력해 주세요.',
            desc: '',
            btnName: '확인'
        },
        {
            idx: 201,
            title: '인증 완료 후 이용해 주세요.',
            desc: '',
            btnName: '확인'
        },
        {
            idx: 202,
            title: '휴대폰 번호를 입력하여 주세요.',
            desc: '',
            btnName: '확인'
        },
        {
            idx: 203,
            title: '정상적으로 해지되었습니다. \n' +
                '이용해 주셔서 감사합니다.',
            desc: '',
            btnName: '확인'
        },
        {
            idx: 204,
            title: '인증번호가 틀렸습니다.',
            desc: '', btnName: '확인'
        },
        {
            idx: 205,
            title: '이용약관',
            desc: InquiryTerms,
            btnName: '확인'
        },
        {
            idx: 206,
            title: '문의가 정상적으로 등록되었습니다.',
            desc: '', btnName: '확인'
        },
        {
            idx: 207,
            title: '보안문자를 입력해 주세요.',
            desc: '',
            btnName: '확인'
        },
        {
            idx: 210,
            title: '인증번호 3회 오류로 만료되었습니다. 다시 진행해 주세요.',
            desc: '',
            btnName: '확인'
        },
        {
            idx: 211,
            title: '유효시간이 초과 되었습니다. 인증번호를 다시 받아 주세요.',
            desc: '', btnName: '확인'
        },
        {
            idx: 212,
            title: '요청 정보가 없습니다.',
            desc: '인증번호를 다시 받아주세요.',
            btnName: '닫기'
        },
        // confirm
        {
            idx: 213,
            title: '인증번호 전송 내역이 존재합니다.<br/> 재전송하시겠습니까?',
            desc: '',
        },
        {
            idx: 215,
            title: '입력하신 번호로 인증번호가 전송되었습니다. \n' +
                '전송된 인증번호를 입력해 주세요.',
            desc: '',
            btnName: '확인'
        },
        {
            idx: 216,
            title: '가입이 완료됐습니다. \n' +
                '전송된 문자를 통해 앱을 설치해주세요.',
            desc: '',
            btnName: '확인'
        },
        {
            idx: 217,
            title: '필수 약관에 동의해주세요.',
            desc: '',
            btnName: '확인'
        },
        {
            idx: 218,
            title: '휴대폰가족보호 안내\n' +
                '휴대폰을 통해 가족 구성원의 상태를 확인하고 도움이 필요한 상황을 알려 안전하게 보호받을 수 있는 안심 유료부가서비스에 가입되셨습니다. 원활한 이용을 위해 [확인] 버튼을 눌러 앱스토어로 이동하세요.',
            desc: '',
            btnName: '확인'
        }
    ]
    return {ModalTextOptions}
}

export default useModalText
